const SRLWrapperOptions = {
  settings: {
    transitionSpeed: 1500,
  },
  caption: { showCaption: false },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: false,
    showDownloadButton: false,
    showFullscreenButton: false,
    showThumbnailsButton: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: { showProgressBar: false },
};

export { SRLWrapperOptions };
